<template>
  <div class="title">
    <div class="container">
      <h1>{{ msg }}</h1>
    </div>
  </div>
  <!-- <Title :msg="wordTitle"></Title> -->
</template>

<script>
export default {
  props: {
    msg: {
      type: String,
      default: 'title',
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.title {
  padding: 20px 0;
  text-align: center;
  background-color: #fff1c9;
  box-shadow: 0px -1px 10px #dac4a9;
  h1 {
    text-align: center;
    font-size: 2.5rem;
    z-index: 1;
  }
}
</style>
